<template>
  <form-field-select
    :label="label"
    v-model="filterValue"
    placeholder="No filter"
    @change="handleInput"
  >
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
    >{{ option.label }}
    </option>
  </form-field-select>
</template>

<script>
export default {
  name: "FilterStatuses",
  props: {
    label: {
      type: String,
      default: "Statuses"
    },
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    statusesName: {
      type: String,
      default: "statuses"
    }
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].statuses;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "statuses",
          value
        ]);
      }
    },
    options() {
      return [
        {id: null, label: "No filter"},
        ...this.$store.getters["pipeline/" + this.statusesName],
      ];
    },
    text() {
      if (this.filterValue) {
        let status = this.$store.getters["pipeline/statuses"].find(status => status.id === this.filterValue);
        return "Only " + status.label;
      } else {
        return null;
      }
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
